// extracted by mini-css-extract-plugin
export default {"root":"IconGooglePay_root__P18d6"};